export default ({ hasPermissions, renderIfHasPermissions }) => (
  hasPermissions && renderIfHasPermissions()
)
